import {createMultiDividerHeadline} from 'Container/OfferDisplay/helpers/components/multideviderHelper';
import {IHeadlineProperties} from '@vfde-brix/headline';
import {IOfferFromJSON} from '../../../../types';
import {createImageCaptionComponent, IImageCaptionProperties} from '@vfde-brix/image-caption';
import {MULTI_DIVIDER_MAX_ITEMS} from 'Constant';
import {
    OFFER_CARD_MULTIDIVIDER_HEADLINE,
    OFFER_CARD_MULTIDIVIDER_IMAGES,
} from 'Container/OfferDisplay/constant';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const getMDItemCount = (offer: IOfferFromJSON) => {
    let count: number = 0;

    for (let i = 1; i <= MULTI_DIVIDER_MAX_ITEMS; i++) {
        if (offer[`MD_Icon_Text_${ i }`] && offer[`MD_Icon_${ i }`]) {
            count++;
        }
    }

    return count;
};

const renderMultiDividerHeadline = (element: HTMLElement, offer: IOfferFromJSON) => {

    const headlineDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_MULTIDIVIDER_HEADLINE)[0];

    const headlineProperties: IHeadlineProperties = {
        optTag: 'h2',
        optAlign: 'center',
        stdContent: offer.Multi_Divider_Headline,
        optVisualLevel: 'h2',
        spacing: '100',
        business: {},
    };

    createMultiDividerHeadline(headlineDIV, headlineProperties);
};

const renderMultiDividerItems = (element: HTMLElement, offer: IOfferFromJSON) => {

    const imageListDIV: HTMLElement = <HTMLElement>element.getElementsByClassName(OFFER_CARD_MULTIDIVIDER_IMAGES)[0];

    for (let i = 1; i <= MULTI_DIVIDER_MAX_ITEMS; i++) {
        const newDIV: HTMLElement = <HTMLElement> document.createElement('div');
        newDIV.classList.add('brix-column', 'brix-mar-bottom-gutter');
        const imageCaptionItem: IImageCaptionProperties = {
            stdAltText: offer[`MD_Icon_Text_${ i }`],
            stdCaption: offer[`MD_Icon_Text_${ i }`],
            imgSrc: offer[`MD_Icon_${ i }`],
            business: NO_PATTERN_BUSINESS_LOGIC,
        };
        createImageCaptionComponent(newDIV, imageCaptionItem);
        imageListDIV.append(newDIV);
    }

};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderMultiDivider = (element: HTMLElement, offer: IOfferFromJSON) => {

    if (4 > getMDItemCount(offer)) {
        element.getElementsByClassName('gigakombi-multi-divider')[0].remove();

        return;
    }

    renderMultiDividerHeadline(element, offer);

    renderMultiDividerItems(element, offer);

};
